import { useTabsForRole } from "features/CenterContent/RoleContent/useTabsForRole";
import TabsCenter from "features/CenterContent/shared/Tabs/TabsCenter";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getDashboardStartPath } from "shared/utils/routes";
import { useDropsRole } from "stores/useDropsRole";

export const RoleContent = () => {
  const { tabIdParam, roleIdParam } = useParams();
  const { role } = useDropsRole();
  const navigate = useNavigate();

  useEffect(() => {
    if (role !== roleIdParam) {
      void navigate(getDashboardStartPath(role));
    }
  }, [role]);

  const TabsForRole = useTabsForRole(role);

  const TabsPage = TabsForRole?.find((it) => it.id === tabIdParam);
  return (
    <>
      <TabsCenter />
      {TabsPage?.content}
    </>
  );
};
